<template lang="html">
  <div class="wrapper">
    <a class="logo" href="http://www.toriyasaimiso.jp/" target="_blank"><img src="../assets/images/logo.svg" alt="株式会社まつや"></a>

    <a class="tab" href="http://www.toriyasaimiso.jp/" target="_blank">
      <img src="../assets/images/btn_header.svg" alt="とり野菜みそオフィシャルサイト">
    </a>
  </div>
</template>

<script>
  export default {
    name: 'GlobalHeader'
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  .wrapper {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 3vw;
    height: 30px;
    background-color: #fff;

    .logo {
      display: block;
      max-width: 185px;
      width: 25vw;
    }

    @include media( sm ) {
      justify-content: center;
      height: 50px;
    }

    @include media( md ) {
      height: 60px;
    }
  }

  a {
    &:hover {
      opacity: .6;
      transition: opacity 200ms ease;
    }
  }

  .tab {
    position: absolute;
    top: 0;
    right: 3vw;
    display: block;

    &::before {
      position: absolute;
      top: 4.5%;
      left: 4%;
      display: block;
      width: 19%;
      height: 100%;
      background: url("../assets/images/img_miso.png") no-repeat;
      background-size: contain;
      content: "";
    }

    img {
      width: 30vw;
      max-width: 309px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/GlobalHeader.vue?73ee7bd3